// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics, isSupported } from "firebase/analytics";

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBN82FKv4irEuxj74Vlv2rRuPlQLXO9Aqw",
  authDomain: "vedyo-21dd6.firebaseapp.com",
  projectId: "vedyo-21dd6",
  storageBucket: "vedyo-21dd6.firebasestorage.app",
  messagingSenderId: "1082371384066",
  appId: "1:1082371384066:web:62609a5410baa04476d81b",
  measurementId: "G-LQPW2WJY5W"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Firestore setup
const db = getFirestore(app);

// Optional: Initialize Analytics (only if supported, e.g. browser)
let analytics = null;
isSupported().then((yes) => {
  if (yes) analytics = getAnalytics(app);
});

export { db, analytics };
